module.exports = __webpack_public_path__ + "static/media/walmart_logo.aac2f47e.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/walmart_logo.png
// module id = 1724
// module chunks = 0